module.exports = "<input #input class=\"form-control\" type=\"checkbox\" />"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/search/category-filter/category-filter.template.html
// module id = 690
// module chunks = 2